import { render, staticRenderFns } from "./OfflineBoundary.vue?vue&type=template&id=1226408d&scoped=true"
import script from "./OfflineBoundary.vue?vue&type=script&lang=js"
export * from "./OfflineBoundary.vue?vue&type=script&lang=js"
import style0 from "./OfflineBoundary.vue?vue&type=style&index=0&id=1226408d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226408d",
  null
  
)

export default component.exports